import { preferencesAreLoaded } from '../brand/brandSelectors';
import { isStillFetchingPromoRewards } from '../promo/promoSelectors';

import { paymentStepPreConditions, paymentStepPostConditions, paymentStepSkippable } from './paymentStepSelectors';
import paymentMethodMessages from '../paymentMethod/paymentMethodMessages';



const paymentStepConfig = {
    component: () => import('./PaymentStep'),
    flow: 'postBuy',
    hideCartLink: true,
    hidePromoBanner: true,
    isReady: state => preferencesAreLoaded(state) && !isStillFetchingPromoRewards(state),
    preConditions: paymentStepPreConditions,
    postConditions: paymentStepPostConditions,
    getSubmitMessage: () => paymentMethodMessages.submitButtonText,
    canSkip: state => (
        paymentStepSkippable(state)
    )
};

export default paymentStepConfig;
